module.exports = __webpack_public_path__ + "static/img/app-bg1.9d96284e.png";